export default function percentage(xValue, totalValue) {
  const calculatingValue = (xValue * 100) / totalValue;
  const rounded = Math.round(calculatingValue);

  return rounded;
}
